/**
 * @file 用户详情页-活动列表
 */

import styled from 'styled-components'

import { InformalReflection } from 'packages/sdks-next/growp'
import { Ellipsis } from '@seiue/ui'

/**
 * 用户详情页-活动列表
 *
 * @param param - 参数
 * @param param.infoData - 用户数据
 * @returns 组件
 */
export const ActivityBox: React.FC<{ infoData: InformalReflection }> = ({
  infoData,
}) => {
  const activities = infoData.activities || []
  return (
    <Box>
      {activities.map((e) => {
        return (
          <CardBox key={e.activity}>
            <CardHeaderBox>
              <CardTitle>
                <Ellipsis text={e.activity} />
              </CardTitle>
              <CardTime>{e.createdAt}</CardTime>
            </CardHeaderBox>
            
          </CardBox>
        )
      })}
    </Box>
  )
}

const Box = styled.div`
  padding-right: 20px;
  padding-top: 32px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const CardBox = styled.div`
  border: 1px solid ${(props) => props.theme.border.greyNormal};
  border-radius: 8px;
  height: 116px;
`

const CardHeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`

const CardTitle = styled.div`
  width: calc(100% - 200px);
  height: 28px;
  font-size: 20px;
`

const CardTime = styled.span`
  display: inline-block;
`
